import styled, { css } from 'styled-components';

import { Typography } from '../../../DesignSystem';

export const StyledSearchSectionTitle = styled.div`
    padding: 0 5px 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.shades.white[5]};
`;

interface StyledSearchListItemWrapperProps {
    $noHover?: boolean;
    $focused?: boolean;
}

export const StyledSearchListItemWrapper = styled.div<StyledSearchListItemWrapperProps>`
    display: grid;
    grid-template-columns: 50px 245px 5px auto;
    align-items: center;
    min-height: 40px;
    padding: 4px 15px 4px 4px;
    border-radius: 6px;
    transition: background 0.2s;
    cursor: pointer;
    background: ${(props) => (props.$focused ? props.theme.colors.purple : props.theme.colors.transparent)};

    &:hover {
        background: ${(props) => (props.$noHover ? props.theme.colors.transparent : props.theme.colors.purple)};
    }
`;

export const StyledSearchListItemSpacer = styled.div`
    flex: 1;
`;

export const THUMBNAIL_STYLES = css`
    border-radius: 5px;
    display: block;
    margin-right: 1em;
    height: 40px;
    width: 40px;
`;

export const StyledThumbnailWrapper = styled.div`
    ${THUMBNAIL_STYLES}
`;

export const StyledThumbnail = styled.img`
    object-fit: cover;
    ${THUMBNAIL_STYLES}
`;

export const StyledThumbnailDoubleWrapper = styled.div`
    ${THUMBNAIL_STYLES};
    object-fit: cover;
    overflow: hidden;
    display: grid;
    grid-template-areas: 'first second';
`;

export const StyledThumbnailTripleWrapper = styled.div`
    ${THUMBNAIL_STYLES};
    object-fit: cover;
    overflow: hidden;
    display: grid;
    grid-template-areas:
        'first second'
        'first third';
`;

export const StyledThumbnailFirstPiece = styled.div`
    grid-area: first;
    display: block;
`;

export const StyledThumbnailSecondPiece = styled.div`
    grid-area: second;
    display: block;
`;

export const StyledThumbnailThirdPiece = styled.div`
    grid-area: third;
    display: block;
`;

export const StyledThumbnailMulti = styled.img`
    &&& {
        object-fit: cover;
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const StyledChip = styled.div`
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 100px;
`;

export const StyledEthIcon = styled.div`
    margin-left: 6px;
    margin-right: 3px;
`;

export const StyledPodStatus = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 8px;
`;

export const StyledPodItem = styled.div`
    &&& {
        h3 {
            margin: 0;
        }
    }
`;

export const StyledTypography = styled(Typography)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px 0;
`;
